import { render, staticRenderFns } from "./RequestPostalAddressInfo.vue?vue&type=template&id=d240211c"
import script from "./RequestPostalAddressInfo.vue?vue&type=script&lang=js"
export * from "./RequestPostalAddressInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports